import InutilizacaoNotaFiscalModel from "../models/inutilizacaoNotaFiscalModel";

import { IService } from "./base/iService";

export default class InutilizacaoNotaFiscalService extends IService<InutilizacaoNotaFiscalModel> {
    constructor() {
        super("InutilizacaoNotaFiscal");
    }
}